import { useCallback, useMemo, useState, type ReactNode } from 'react'
import { ScanModeContext, type ScanMode, type ScanModeState } from './scanModeContext'

/**
 * Add/remove mode lives above the screens because the red full-screen frame that marks
 * remove mode is painted by the shell, while the toggle that sets it lives on the pallet
 * screen. Mode resets to add on every pallet entry — a stale remove mode is how an
 * operator takes items off a pallet they meant to fill.
 */
export function ScanModeProvider({ children }: { children: ReactNode }) {
  const [mode, setModeState] = useState<ScanMode>('add')

  const setMode = useCallback((next: ScanMode) => setModeState(next), [])

  const value = useMemo<ScanModeState>(() => ({ mode, setMode }), [mode, setMode])

  return <ScanModeContext.Provider value={value}>{children}</ScanModeContext.Provider>
}
